// alpine func
requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
        Alpine.data('loadingSplash', () => ({
            splashHide: {
                [':class']: "loaded && 'opacity-0 pointer-events-none'",
                ['x-effect']: "if (loaded) setTimeout(() => { $el.classList.toggle('hidden',loaded) }, 1200)"
            }
        })),
            Alpine.data('mainBanner', () => ({
                blurIn: {
                    ['x-effect']: "loaded && $el.classList.remove('blur-lg')"
                },
                fadeIn: {
                    ['x-effect']: "loaded && $el.classList.remove('opacity-0')"
                }
            })),
            Alpine.data('aoiskrSection', () => ({
                active: false,
                sectionCollab: {
                    ['x-intersect:enter.once.threshold.10']: "active = true"
                },
                section: {
                    ['x-intersect:enter.once.threshold.10']: "active = true",
                    [':class']: "active || 'opacity-0 translate-y-6'"
                },
                contents: {
                    [':class']: "active || 'opacity-0 translate-y-4'"
                }
            })),
            Alpine.data('nav', () => ({
                showFixed: false,
                normalBtn: {
                    ['x-intersect:enter']: "showFixed = false",
                    ['x-intersect:leave']: "showFixed = true"
                },
                fixedBtn: {
                    ['x-show']: "showFixed",
                    ['x-transition.opacity']: ""
                },
                navItem: {
                    ['@click.prevent']: "scrollTo({ top : Math.floor(document.querySelector($el.getAttribute('href')).offsetTop - 50), behavior: 'auto' })"
                },
                navItemMobile: {
                    ['@click.prevent']: "scrollTo({ top : Math.floor(document.querySelector($el.getAttribute('href')).offsetTop - 10), behavior: 'auto' })"
                },
                section: {
                    ['x-intersect:enter.once.threshold.10']: "active = true",
                    [':class']: "active || 'opacity-0 translate-y-6'"
                },
                contents: {
                    [':class']: "active || 'opacity-0 translate-y-4'"
                }
            })),
            Alpine.data('topBtn', () => ({
                show: false,
                topBtnEl: {
                    ['@scroll.window.debounce.150ms']: "window.scrollY > window.innerHeight / 2 ? show = true : show = false",
                    ['@click']: "window.scrollTo({ top: 0, behavior: 'auto' })",
                    ['x-show']: 'show',
                    ['x-transition.opacity']: ''
                }
            }));
    });
});
